import createApi from '@/services/Api';

function Professional() {
  const api = createApi();

  function toggleDuty(onDuty) {
    return onDuty ? dutyOn() : dutyOff();
  }

  function dutyOn() {
    const endpoint = `/profissional-saude/profissionais/plantoes/iniciar`;
    return api.post(endpoint);
  }
  function dutyOff() {
    const endpoint = `/profissional-saude/profissionais/plantoes/finalizar`;
    return api.post(endpoint);
  }

  async function fetchCurrDutyState() {
    const endpoint = '/profissional-saude/profissionais/plantoes';

    try {
      const response = await api.get(endpoint);
      return Promise.resolve(response.data.flagPlantao || false);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  return {
    toggleDuty,
    fetchCurrDutyState,
  };
}

export default Professional();
